import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const PinterestIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 23",
    fill: "currentColor",
    width: size || '1em',
    height: size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "currentColor",
    d: "M7.9,15.2c-0.9,3.3-1,4-1.9,5.6c-0.4,0.7-0.9,1.4-1.5,2.1L4.2,23l-0.2-0.2c-0.2-1-0.2-2-0.2-3 c0-1.3,0.2-1.8,2-8.9l0-0.3C5.4,9.4,5.4,8.3,5.7,7.1C6.6,4.7,9.5,4.5,10,6.5c0.3,1.2-0.5,2.9-1.2,5.3c-0.5,2,2,3.4,4.1,2 c2-1.3,2.7-4.6,2.6-6.8c-0.3-4.5-5.6-5.5-9-4.1c-3.9,1.7-4.7,6.2-3,8.2c0.2,0.3,0.4,0.4,0.3,0.7c-0.1,0.4-0.2,0.8-0.3,1.2 c-0.1,0.3-0.4,0.4-0.7,0.3c-0.6-0.2-1.2-0.6-1.6-1.1c-1.5-1.7-1.9-5.1,0.1-8C3.5,1,7.5-0.3,11.2,0.1c4.4,0.5,7.2,3.3,7.7,6.5 c0.2,1.5,0.1,5.1-2.1,7.6c-2.5,2.9-6.6,3.1-8.5,1.3c-0.1-0.1-0.3-0.3-0.4-0.5L7.9,15.2z"
  }));
};
PinterestIcon.displayName = 'PinterestIcon';
export default PinterestIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PinterestIcon.js.map